import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from "recharts";
import { fmtEUR } from "../lib/format";

const MONTH_NAMES = ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"];

export default function TrendChart() {
  const [data, setData] = useState([]);

  useEffect(() => {
    api.get("/dashboard/won-delivered", { params: { months: 6 } }).then((r) => {
      setData(r.data.map((d) => {
        const [y, m] = d.month.split("-");
        return { ...d, label: `${MONTH_NAMES[parseInt(m) - 1]} '${y.slice(-2)}` };
      }));
    });
  }, []);

  return (
    <div className="border border-neutral-200 bg-white p-6" data-testid="trend-chart">
      <div className="flex items-start justify-between mb-4">
        <div>
          <div className="mono-label">Trend</div>
          <h2 className="font-display text-xl font-medium mt-1">Parcella acquisita vs consegnata · 6 mesi</h2>
        </div>
        <div className="flex items-center gap-3 text-xs">
          <div className="flex items-center gap-1.5"><div className="h-0.5 w-4" style={{ background: "var(--brand-primary)" }} /> Acquisito</div>
          <div className="flex items-center gap-1.5"><div className="h-0.5 w-4" style={{ background: "#E8935C" }} /> Consegnato</div>
        </div>
      </div>
      <div className="h-56">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data} margin={{ top: 5, right: 10, left: 0, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
            <XAxis dataKey="label" tick={{ fontSize: 11, fontFamily: "JetBrains Mono", fill: "#6b7280" }} tickLine={false} axisLine={{ stroke: "#e5e5e5" }} />
            <YAxis tick={{ fontSize: 11, fontFamily: "JetBrains Mono", fill: "#6b7280" }} tickLine={false} axisLine={{ stroke: "#e5e5e5" }} tickFormatter={(v) => `${(v / 1000).toFixed(0)}k`} />
            <Tooltip contentStyle={{ border: "1px solid #e5e5e5", borderRadius: 2, fontSize: 12 }} formatter={(v) => fmtEUR(v)} />
            <Line type="monotone" dataKey="won" name="Acquisito" stroke="var(--brand-primary)" strokeWidth={2.5} dot={{ r: 4, fill: "var(--brand-primary)" }} />
            <Line type="monotone" dataKey="delivered" name="Consegnato" stroke="#E8935C" strokeWidth={2.5} dot={{ r: 4, fill: "#E8935C" }} />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
